import styled from 'styled-components'

const Style = styled.div.attrs((props) => ({ className: props.className }))`
  width: 100%;
    
  .reset {
    width: var(--sp51x);
    background-color: var(--white);
    border-radius: 20px;
    position: relative;
    padding: var(--sp5x);
    margin-top: var(--sp10x);
    margin-bottom: var(--sp10x);

    .op-close {
      position: absolute;
      top: var(--sp5x);
      right: var(--sp5x);
    }

    .title {
      margin-bottom: var(--sp3x);
    }

    .subtitle {
      margin-bottom: var(--sp4x);
    }

    .input-text {
      margin-bottom: var(--sp2x);
    }

    .ant-form-item {
      margin-bottom: 0;
    }

    .reset {
      font-size: 14px;
    }

    .done-btn {
      align-self: flex-start;
      margin-top: var(--sp4x);
    }

    .check {
        span {
            text-align: center;
        }
    }
  }

  @media only screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
    height: 100%;
    justify-content:center;
    
    & > div {
      width: 100%;
    }

    .reset {
      width: calc(100% - var(--sp4x));
      padding: var(--sp2-5x);
      margin-left:auto;
      margin-right:auto;

      .op-close {
        top: var(--sp3x);
        right: var(--sp2-5x);
      }

      .done-btn {
        margin-right: var(--sp2x);
      }
    }
  }
`
export default Style
